import React from "react";
import PropTypes from "prop-types";

//
import { Form, Button } from "react-bootstrap";
function Explanation({ explanation, setExplanation, setStep, hideModal }) {
  return (
    <div className="explanation">
      <Form.Group>
        <Form.Control
          as="textarea"
          placeholder="Your Explanation is entirely optional..."
          className="no-resize"
          value={explanation}
          onChange={(e) => setExplanation(e.target.value)}
        />
      </Form.Group>

      <div className="actions">
        <div className="back" onClick={() => hideModal()}>
          Cancel
        </div>

        <Button
          variant="info"
          size="lg"
          onClick={() => setStep(3)}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}

Explanation.propTypes = {
  setStep: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  explanation: PropTypes.string.isRequired,
  setExplanation: PropTypes.func.isRequired,
};

export default Explanation;
